import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatomoTracker } from '@ngx-matomo/tracker';
import { PoDynamicFormField, PoListViewAction, PoModalAction, PoModalComponent, PoNotification, PoNotificationService, PoSwitchLabelPosition, PoTagType, PoSelectOption } from '@po-ui/ng-components';
import { Observable, Subject } from 'rxjs';
import { Bases } from 'src/app/classes/Bases';
import { IniParameter } from 'src/app/classes/ProtheusINI';
import { MainService } from '../../app.service';
import { Binarios } from '../../classes/Binarios';
import { Localizacoes } from '../../classes/Localizacoes';
import { Protheus } from '../../classes/Protheus';
import { Releases } from '../../classes/Releases';
import { Region } from '../../classes/Region';
import { Software } from '../../classes/Software';
import { Rpo } from '../../classes/Rpo';
import { NotificationServiceHM } from '../notification-item/notification-item.service';
import { ProtheusService } from './protheus.service';
interface objectForm {
  label: string,
  property: string,
  required: boolean,
  minLength?: number,
  maxLength?: number,
  gridColumns: number,
  gridSmColumns: number,
  fieldValue: any,
  disabled: boolean,
  divider?: string,
  value?: string
}

interface tempIniGroup {
  group?: string,
  keys?: object[]
}

@Component({
  selector: 'app-protheus',
  templateUrl: './protheus.component.html',
  styleUrls: ['./protheus.component.css']
})



export class ProtheusComponent implements OnInit {

  @ViewChild('detailsModal', {static: false}) protheusDetailsModal: PoModalComponent;
  @ViewChild('createModal', {static: false}) createProtheusModal: PoModalComponent;
  @ViewChild('updateModal', {static: false}) protheusUpdateModal: PoModalComponent;
  @ViewChild('deleteModal', {static: false}) deleteProtheusModal: PoModalComponent;
  @ViewChild('shareModal', {static: false}) shareModal: PoModalComponent;
  @ViewChild('editINIModal', {static: false}) editINIProtheusModal: PoModalComponent;
  @ViewChild('insertFieldModal', {static: false}) insertFieldModal: PoModalComponent;


  constructor(private router: Router,
    public mainService: MainService,
    private protheusService: ProtheusService,
    public poNotificationService: PoNotificationService,
    public notificationServiceHM: NotificationServiceHM,
    private readonly tracker: MatomoTracker) { }

  loading: boolean = false;
  unsubscribe$ = new Subject<void>();
  protheus: any[] = [];
  protheusFiltered: any[] = [];

  binarios: any[] = [];
  binariosSelect: any[] = [];

  dbaccess: any[] = [];
  dbaccessSelect: any[] = [];

  localizacoes: any[] = [];
  localizacoesSelect: any[] = [];
  idiomas: any[] = [];
  rpos: any[] = [];
  rposSelect: any[] = [];

  bases: any[] = [];
  baseSelect: any[] = [];
  baseById: Object = {};

  releases: any[] = [];
  releasesSelect: any[] = []

  _protheusSelected: Object = {};
  _id: string = '';
  _name: string = '';
  _ini: string = '';
  _release: string = '';
  _localizacao: string = '';
  _idioma: string = '';
  _appserver: string = '';
  _appserverId: string = '';
  _dbaccess: string = '';
  _rpo: string = '';
  _rest: boolean = false;
  _mpp: boolean = true;
  _telnet: boolean = false;
  _webservices: boolean = false;
  _sgdbType: any = undefined;
  _sgdbKind: any = undefined;
  _baseName: string = '';
  _expirationDays: number = 0;
  _shared: string[] = [''];
  _iniToEdit: Array<any> = [ ];
  _fullINIToEdit: Array<any> = [ ];
  objetosIni: Array<any> = [ ];
  objetoSelecionado: any = {};
  iniObject: any = {};
  previousIni: any = {};
  iniInstance: string = '';
  iniType: string = '';
  _configsToEditIni = {};
  iniToEditFields: Array<PoDynamicFormField> = [ ];
  iniToEditValues: any = {};
  iniToEditGroups: Array<any> = [];
  newGroup: boolean = false;
  insertField: boolean = true;
  deleteField: boolean = false;
  insertDeleteField: boolean = true;
  fieldsToSelect: Array<any> = [];
  fieldsToDelete: Array<any> = [];
  groupINI: string = '';
  _newGroup: string = '';
  newFieldsINI: Array<PoDynamicFormField> = [ ];
  newValuesINI: Record<string, any> = {};
  iniToEditValuesSaved = {};
  INIformVisible = false;
  status_Processing: Array<string> = [
    'creating database',
    'creating protheus',
    'restarting protheus',
    'starting protheus',
    'stopping protheus',
    'editing protheus ini',
    'reseting protheus ini',
    'backuping database',
    'restoring database',
    'deleting protheus',
    'deleting database',
  ]

  status_active: Array<string> = [
    'creating database',
    'creating protheus',
    'deployed',
    'expiring',
    'restarting protheus',
    'starting protheus',
    'stopping protheus',
    'editing protheus ini',
    'reseting protheus ini',
    'expired',
    'backuping database',
    'restoring database',
    'deleting protheus',
    'deleting database',
  ]

  status_deleted: Array<string> = [
    'deleting',
    'deleting protheus',
    'deleting database',
    'deleted',
    'failed'
  ]

  expiraOptions: Array<any> = [
    { label: '20', value: 20 },
    { label: '40', value: 40 }
  ];

  message: string = '';
  poNotification: PoNotification = {
    message: this.message,
    action: undefined
  };

  labelPosition: PoSwitchLabelPosition = PoSwitchLabelPosition.Left;

  filterInstancesModel: Object = {
    active: true,
    deleted: false,
    expired: false,
    failed: false
  }

  filterOptionsSelect: Array<any> = [
    { label: "Nome", value: "name"  },
    { label: "Status", value: "deployStatsDataResume"  },
    { label: "Data de Criação", value: "createdAt"  },
    { label: "Expiração", value: "remainingTime"  },
  ]
  ascendingDescending: boolean = true;
  filterToggle: boolean = false;

  itemOptionsObject: Array<PoListViewAction> = [
    { label: 'Detalhes', action: this.detalhesProtheus.bind(this) },
    { label: 'Renomear/Prorrogar', action: this.updateProtheus.bind(this), disabled: this.cannotRename.bind(this) },
    { label: 'Editar INI', action: this.getOriginalIniToModifiy.bind(this), disabled: this.cannotEditINI.bind(this) },
    { label: 'Reiniciar', action: this.restartProtheus.bind(this), disabled: this.cannotRestart.bind(this)},
    { label: 'Compartilhar', action: this.shareResource.bind(this), disabled: this.cannotShare.bind(this) },
    { label: 'Deletar', action: this.deleteProtheus.bind(this), disabled: this.cannotDelete.bind(this) }
  ];


  createProtheusExecute: PoModalAction = {
    action: () => {
      let observable: Observable<{kind?: string}>;

      const dbTags = this._tagsSelected.map(e1 => e1.value);
      const proTags = this._protheusTagsSelected.map(e1 => e1.value);

      if (this._sgdbKind === 'template') {
        observable = this.protheusService.createProtheus2(this._name, this._release, this._appserverId, this._dbaccess, this._localizacao, this._rpo, this._rest, this._mpp, this._sgdbType, this._expirationDays, this._telnet, this._webservices, dbTags, proTags);
      } else {
        observable = this.protheusService.createProtheus(this._name, this._release, this._appserverId, this._dbaccess, this._localizacao, this._rpo, this._rest, this._mpp, this._sgdbType, this._expirationDays, this._telnet, this._webservices);
      }

      observable.subscribe((res) => {
        this.poNotification.message = "Base Protheus em processo de criação";
        this.poNotificationService.success(this.poNotification);
      });

      this.createProtheusModal.close();
      this.getAllProtheus();
    },
    label: 'Criar'
  };

  deleteApprove = 'NO';
  deleteProtheusExecute: PoModalAction = {
    action: () => {
      if (this.deleteApprove === 'YES') {
        this.protheusService.deleteProtheus (this._id)
        .subscribe(
          res => {
            this.poNotification.message = "Base Protheus em processo de remoção";
            this.poNotificationService.success(this.poNotification);
          }
        );
        this.getAllProtheus();
      } else {
        this.notificationServiceHM.showToast(`Operação de delete cancelada!`, 'warning');
      }
      this.deleteProtheusModal.close();
      this.deleteApprove = "NO";
    },
    label: 'Confirmar'
  };

  getUpdateData(event: { _name: string, _expirationDays: number}){
    this._name = event._name;
    this._expirationDays = event._expirationDays;
  }

  updateProtheusExecute: PoModalAction = {
    action: () => {
      if (this._sgdbKind !== 'template') {
        this.protheusUpdateModal.close();
        return;
      }

      this.loading = true;
      setTimeout(() => {
        this.protheusService.updateProtheus(this._id, this._name, this._expirationDays)
        .subscribe(
          res => {
            this.poNotification.message = "Registro atualizado com sucesso!";
            this.poNotificationService.success(this.poNotification);
          }
        );
        this.protheusUpdateModal.close();
        this.getAllProtheus();
        this.loading = false;
      }, 500)
    },
    label: 'Criar'
  };

  editINIProtheusExecute: PoModalAction = {
    action: () => {
      this.convertValuesToINI();
    },
    label: 'Salvar'
  };

  editINIProtheusCancel: PoModalAction = {
    action: () => {
      this.resetIniValues();
    },
    label: 'Cancelar'
  };

    // - SHARE - //
    protheusIdToShare: string = '';
    usersSelected: Array<any> = [];
    usersInArea: Array<any> = [];

    getUpdateSharedData(event: { usersSelected: Array<any>}){
      this.usersSelected = event.usersSelected;
    }

    okShare: PoModalAction = {
      action: () => {
          this.shareInstance();
          this.loading = false;
          this.shareModal.close();
      },
      label: 'Compartilhar'
    };

    cancelShare: PoModalAction = {
      action: () => {
        this.loading = false;
        this.shareModal.close();
      },
      label: "Cancelar"
    };

  ngOnInit() {
    this.tracker.trackPageView('Protheus');
    this.getAllReleases();
    this.getRegions();
    this.loading = false;
  }

  getAllProtheus(){
    this.loading = true
    this.protheus = [ ];
    this.protheusFiltered = [];
    this.protheusService.getProtheus()
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
            const protheusTemp = new Protheus();
            protheusTemp.id = element.id;
            protheusTemp.name = element.name;
            protheusTemp.username = element.username;
            protheusTemp.deployStats = element.deployStats;
            protheusTemp.deployStatsData = element.deployStatsData;

            if ( element.deployStatsData !== undefined && element.deployStatsData.hasOwnProperty('message') ) {
              protheusTemp.deployStatsDataResume = element.deployStats + ' - ' + element.deployStatsData['message'];
            } else {
              protheusTemp.deployStatsDataResume = element.deployStats;
            }

            if (this.status_Processing.includes(element.deployStats.toLowerCase())) {
              protheusTemp.statusType = PoTagType.Warning;
              protheusTemp.active = true;
            } else if (element.deployStats === 'expiring') {
              protheusTemp.statusType = PoTagType.Warning;
              protheusTemp.active = true;
            } else if (element.deployStats === 'expired' || element.deployStats === 'failed') {
              protheusTemp.statusType = PoTagType.Danger;
              protheusTemp.active = true;
            } else if (element.deployStats === 'deleted') {
              protheusTemp.statusType = PoTagType.Info;
              protheusTemp.active = false;
            } else {
              protheusTemp.statusType = PoTagType.Success;
              protheusTemp.active = true;
            }

            const hasBroker = element.artifacts.some((artifact) => artifact.kind.toLowerCase() === "broker");

            protheusTemp.sgdbData = element.sgdbData;
            protheusTemp.artifacts = hasBroker ? element.artifacts.filter((artifact) =>
              artifact.kind.toLowerCase() !== "appserver" || artifact.name === 'smartclient'
            ).map((artifact) => {
              if (artifact.kind.toLowerCase() === "broker") {
                artifact.kind = "Appserver";
              }

              return artifact;
            }) : element.artifacts;

            let artifactIndex;
            artifactIndex = protheusTemp.artifacts.find(obj => obj.name.toString() === 'webapp');
            if (artifactIndex) {
              const appserverSpec = element.specs.appserver.find(spec => spec.name === 'appserver-service') || element.specs.appserver[0];

              if (appserverSpec?.modifiedIni !== undefined ){
                const hasMpp = appserverSpec.modifiedIni.drivers['multiprotocolport'] !== undefined && appserverSpec.modifiedIni.drivers['multiprotocolport'] === '1' && appserverSpec.modifiedIni.general['app_environment'] !== '';

                if (!hasBroker && hasMpp) {
                  let artifactPortIndex = protheusTemp.artifacts.find(obj => obj.name.toString() === 'smartclient');
                  let urlTemp = ''
                  if (artifactPortIndex) {
                    urlTemp = 'http://' + artifactIndex.ip.toString() + ':' + artifactPortIndex.port.toString() + '/webapp';
                  } else {
                    urlTemp = 'http://' + artifactIndex.ip.toString() + ':' + 'porta não encontrada - usar porta do smartclient';
                  }

                  artifactIndex = protheusTemp.artifacts.indexOf(artifactIndex);
                  protheusTemp.artifacts[artifactIndex].url = urlTemp
                } else {
                  const urlBase = 'http://' + artifactIndex.ip.toString() + ':' + artifactIndex.port.toString();
                  const urlTemp = hasBroker && hasMpp ? urlBase + '/webapp' : urlBase;
                  artifactIndex = protheusTemp.artifacts.indexOf(artifactIndex);
                  protheusTemp.artifacts[artifactIndex].url = urlTemp
                }
              }
            };

            let artifactFBIndex;
            artifactFBIndex = protheusTemp.artifacts.find(obj => obj.name.toString().toLowerCase() === 'filebrowser');
            if (artifactFBIndex) {
              let urlTemp = 'http://' + artifactFBIndex.ip.toString() + ':' +  artifactFBIndex.port.toString()
              let nameTemp = artifactFBIndex.name.toLowerCase();
              artifactFBIndex = protheusTemp.artifacts.indexOf(artifactFBIndex);
              protheusTemp.artifacts[artifactFBIndex].url = urlTemp
              protheusTemp.artifacts[artifactFBIndex].name = nameTemp;
            }

            protheusTemp.sgdbDataResume = 'Login: ' + element.sgdbData.username + ' - Senha: ' + element.sgdbData.password;
            protheusTemp.releaseLocResume = this.getReleaseName(element.specs.release.releaseId);
            if (element.expirationDate) {
              const today = new Date();
              const expirationDate = new Date(element.expirationDate.split('T', 1)[0]);
              protheusTemp.remainingTime = Math.floor((Math.abs(today.valueOf() - expirationDate.valueOf()))/(1000*60*60*24));
            } else {
              protheusTemp.remainingTime = 0;
            }
            protheusTemp.createdAt = element.createdAt.split('T', 1);
            protheusTemp.updatedAt = element.updatedAt.split('T', 1);
            protheusTemp.shared = element.shared;

            this.protheus = [...this.protheus, protheusTemp];
            if (this.status_active.includes(element.deployStats)) {
                  this.protheusFiltered = [...this.protheusFiltered, protheusTemp];
                }

          });
          this.loading = false;
        }),
        error: ((msgError) => {
          this.mainService.handleError(msgError);
          this.loading = false;
        })
      });
  }

  getProtheusbyID(protheusId){
    this.loading = true;
    this.protheusService.getProtheusbyID(protheusId)
      .subscribe({
          next: ((element) => {
                this._id = protheusId;
                this._name = element.name;
                this._protheusSelected = element;
                this.getBasebyID(element['sgdbData']);
                this.loading = false;
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });
  }

  getAllReleases() {
    this.loading = true
    this.releases = [ ];
    this.protheusService.getReleases()
      .subscribe({
          next: ((response) => {
            response.forEach(element => {
                const releaseTemp = new Releases();
                releaseTemp.id = element._id;
                releaseTemp.name = element.name;
                releaseTemp.idioma = element.idiomas;
                releaseTemp.valid = element.valid;

                this.releases = [...this.releases, releaseTemp];

                if (this.mainService.userToken.role === 'superuser') {
                  this.releasesSelect = [...this.releasesSelect, { label: element.name, value: element._id }];
                } else {
                  if ( element.valid ) {
                    this.releasesSelect = [...this.releasesSelect, { label: element.name, value: element._id }];
                  }
                }

              });
              this.getAllProtheus();
              this.loading = false;
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });

  }

  resetFields(from: 'release' | 'idioma' | 'localizacao' | 'rpo' | 'appserver' | 'dbaccess' | 'software' | 'database') {
    // essa construção esquisita, é porque nosso projeto não permite switch case sem break
    // para mais detalhes:
    // https://www.typescriptlang.org/tsconfig/#noFallthroughCasesInSwitch

    const p = { release: 0, idioma: 1, localizacao: 2, rpo: 3, appserver: 4, dbaccess: 5, software: 6, database: 7 }[from];

    if (p <= 0) {
      this._idioma = '';
      this.idiomas = [];
      this.localizacoes = [];
      this.localizacoesSelect = [];
      this.binarios = [];
      this.binariosSelect = [];
    }

    if (p <= 1) {
      this._localizacao = '';
    }

    if (p <= 2) {
      this._rpo = '';
      this.rpos = [];
      this.rposSelect = [];
      this.bases = [];
      this.baseSelect = [];
      this.baseSelectOrig = [];
    }

    if (p <= 3) {
      this._appserver = '';
      this._appserverId = '';
    }

    if (p <= 4) {
      this._dbaccess = '';
      this.dbaccess = [];
      this.dbaccessSelect = [];
    }

    if (p <= 5) {
      this.softwareSelected = '';
    }

    if (p <= 6) {
      this._sgdbType = undefined;
      this._sgdbKind = undefined;
    }

    this.resetTagsValues();
    this.resetProtheusTagsValues();

    if (this.regionSelected) {
      this.pushTagsValues(this.regionSelected.name, false);
      this.pushProtheusTagsValues(this.regionSelected.name, false);
    }
  }

  onChangeRelease(releaseSelected) {
    this.loading = true;
    this.resetFields('release');

    this.getLocalizacoes(releaseSelected);
    this.getBinarios(releaseSelected);

    this.releases.map(releaseItem => {
      if (releaseItem.id === releaseSelected) {
        releaseItem.idioma.forEach(element => {
          this.idiomas = [...this.idiomas, { label: element, value: element }];
        });
      }
    });
    if (this.idiomas.length === 0) {
      this.idiomas = [{ label: 'NOT FOUND', value: 'NOT FOUND' }];
    }

    this.loading = false;
  }

  onChangeIdioma(idiomaSelected) {
    this.resetFields('idioma');
  }

  getLocalizacoes(releaseId) {
    this.localizacoes = [ ];
    this.loading = true;
    this.protheusService.getLocalizacoes(releaseId)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
                const protheusTemp = new Localizacoes();
                protheusTemp.id = element._id;
                protheusTemp.release = element.release;
                protheusTemp.localizacao = element.locale;
                protheusTemp.link_menu = element.link_menu;
                protheusTemp.link_help = element.link_help;
                protheusTemp.link_dic = element.link_dic;
                protheusTemp.published = element.published;

                if (this.mainService.userToken.role === 'superuser') {
                  this.localizacoes = [...this.localizacoes, protheusTemp];
                  this.localizacoesSelect = [...this.localizacoesSelect, { label: element.locale, value: element._id }];
                } else {
                  if ( protheusTemp.published ) {
                    this.localizacoes = [...this.localizacoes, protheusTemp];
                    this.localizacoesSelect = [...this.localizacoesSelect, { label: element.locale, value: element._id }];
                  }
                }

              });
              this.loading = false;
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });
  }

  onChangeLocalizacao(localizacaoSelected) {
    this.loading = true;
    this.resetFields('localizacao');
    this.getRPO(this._release, this._localizacao, this._idioma);
    this.getBases(this._release, this._localizacao);
  }

  onChangeRPO(rpoSelected) {
    this.resetFields('rpo');
  }

  onChangeBinary(binarySelected) {
    this.resetFields('appserver');
    this.getDbAccess(this._release, binarySelected);
  }

  onChangeDbaccess(dbaccessSelected) {
    this.resetFields('dbaccess');
    this.getBinariosFilter(this._release, this._appserver, dbaccessSelected);
  }

  getBinarios(releaseId) {
    this.binarios = [ ];
    this.loading = true;
    this.protheusService.getBinarios(releaseId)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
                const protheusTemp = new Binarios();
                protheusTemp.id = element._id;
                protheusTemp.release = element.release;
                protheusTemp.appserver_version = element.appserver_version;
                protheusTemp.appserver_image = element.appserver_image;
                protheusTemp.dbaccess_version = element.dbaccess_version;
                protheusTemp.dbaccess_image = element.dbaccess_image;
                protheusTemp.published = element.published;

                if (this.mainService.userToken.role === 'superuser') {
                  this.binarios = [...this.binarios, protheusTemp];
                  this.binariosSelect = [...this.binariosSelect, { label: element.appserver_version, value: element.appserver_version }];
                } else {
                  if ( protheusTemp.published ) {
                    this.binarios = [...this.binarios, protheusTemp];
                    this.binariosSelect = [...this.binariosSelect, { label: element.appserver_version, value: element.appserver_version }];
                  }
                }
              })
            }),
              error: ((msgError) => {
                this.mainService.handleError(msgError);
                this.loading = false;
              })
          });
  }

  getBinariosFilter(releaseId, appserver, dbaccess) {
    this.protheusService.getBinariosFilter(releaseId, appserver, dbaccess)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
                const protheusTemp = new Binarios();
                protheusTemp.id = element._id;
                protheusTemp.release = element.release;
                protheusTemp.appserver_version = element.appserver_version;
                protheusTemp.appserver_image = element.appserver_image;
                protheusTemp.dbaccess_version = element.dbaccess_version;
                protheusTemp.dbaccess_image = element.dbaccess_image;
                protheusTemp.published = element.published;

                this._appserverId = element._id;

              });
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });
  }

  getDbAccess(releaseId, binary_version) {
    this.loading = true;
    this.dbaccess = [ ];
    this.protheusService.getDbAccess(releaseId, binary_version)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
                  this.dbaccessSelect = [...this.dbaccessSelect, { label: element, value: element }];
              });
              this.loading = false;
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });

  }

  getRPO(releaseId, localizacaoId, idioma) {
    this.rpos = [ ];
    this.loading = true;
    this.protheusService.getRPOs(releaseId, localizacaoId)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
                const protheusTemp = new Rpo();
                protheusTemp.id = element._id;
                protheusTemp.release = element.release;
                protheusTemp.version = element.version;
                protheusTemp.idioma = element.idioma;
                protheusTemp.localizacao = element.localizacao;
                protheusTemp.link_rpo = element.link_rpo;
                protheusTemp.published = element.published;
                if (this.mainService.userToken.role === 'superuser') {
                  this.rpos = [...this.rpos, protheusTemp];
                  if (element.idioma === idioma) {
                    this.rposSelect = [...this.rposSelect, { label: element.version + ' - ' + element.idioma, value: element._id }];
                  }
                } else {
                  if ( protheusTemp.published ) {
                    this.rpos = [...this.rpos, protheusTemp];
                    if (element.idioma === idioma) {
                      this.rposSelect = [...this.rposSelect, { label: element.version + ' - ' + element.idioma, value: element._id }];
                    }
                  }
                }

              });
              this.loading = false;
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
            })
        });

  }

  getBases(releaseId, localizacaoId) {
    this.loading = true;
    this.protheusService.getBases(releaseId, localizacaoId)
      .subscribe({
        next: ((response) => {
          response.forEach(element => {
            const protheusTemp = new Bases();
            protheusTemp.id = element._id;
            protheusTemp.release = element.release;
            protheusTemp.localizacao = element.localizacao;
            protheusTemp.tipo = element.tipo;
            protheusTemp.dbAlias = element.dbAlias;
            protheusTemp.recipeId = element.recipeId;
            protheusTemp.kind = element.kind;
            protheusTemp.published = element.published;

            let label = element.kind === 'template' ? (element.displayName ?? element.name) : this.generateBaseDescription(element.dbAlias, element.tipo, element.localizacao, element.release);

            if (this.mainService.userToken.role === 'superuser') {
              this.bases = [...this.bases, protheusTemp];
              this.baseSelect = [...this.baseSelect, { label: label, value: element._id }];
            } else {
              if ( protheusTemp.published === true ) {
                this.bases = [...this.bases, protheusTemp];
                this.baseSelect = [...this.baseSelect, { label: label, value: element._id }];
              }
            }
          });
              this.loading = false;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });

  }

  generateBaseDescription(sgdb: string, tipo: string, locale: string, release: string){
    let releaseName: string = this.getReleaseName(release);
    let localeName: string = this.getLocaleName(locale);

    switch (tipo) {
      case 'inicializada':
        return sgdb + ' - ' + tipo + ' - ' + releaseName + ' - 99 + dic';
      case 'congelada':
        if ( localeName === 'Brasil' ) {
          return sgdb + ' - ' + tipo + ' - ' + releaseName + ' - EXP';
        } else {
          return sgdb + ' - ' + tipo + ' - ' + releaseName + ' - MNT';
        }
    }
    return "NOT FOUND";
  }

  getBasebyID(baseObj) {
    let serviceFunction = this.protheusService.getBasebyID;
    let identification = baseObj.type;

    if (baseObj.templateId) {
        serviceFunction = this.protheusService.getTemplatebyID;
        identification = baseObj.templateId;
    }

    this.loading = true;
    serviceFunction.call(this.protheusService, identification)
      .subscribe({
        next: ((response) => {
          this.baseById = response;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });
  }

  filterBaseItem(id: string) {
    let filtered = this.bases.filter(x => x.id == id);
    if (filtered.length < 1) return 'NOT FOUND';
    else return filtered[0];
  }

  onChangeBase(base) {
    this.resetFields('database');
    let baseSelecionada = this.filterBaseItem(base);
    this._sgdbKind = baseSelecionada.kind;
    this.pushTagsValues(this.softwareSelected, false);
  }

  toggleFilters() {
    this.filterToggle = !this.filterToggle;
   }

  filteredData(event: Array<any>){
    this.protheusFiltered = event;
  }

  createProtheus() {
    this._name = '';
    this._release = '';
    this._rest = false;
    this._telnet = false;
    this._webservices = false;
    this.resetFields('release');
    this.createProtheusModal.open();
  }

  detalhesProtheus(protheusSelected) {
    this._id = '';
    this._name = '';
    this.getProtheusbyID(protheusSelected['id']);
    this.protheusDetailsModal.open();
  }

  restartProtheus(protheusSelected) {
    this.protheusService.restartProtheus(protheusSelected['id'])
      .subscribe({
        next: ((response) => {
              this.poNotification.message = 'Base' + response.name + 'sendo reiniciada!';
              this.poNotificationService.success(this.poNotification);
              this.getAllProtheus();
            }),
            error: ((msgError) => {
              this.mainService.handleError(msgError);
              this.loading = false;
              this.poNotification.message = 'Erro ao reiniciar a base!';
              this.poNotificationService.error(this.poNotification);
            })
        });
  }

  updateProtheus(protheusSelected) {
    this._id = protheusSelected['id'];
    this._name = protheusSelected['name'];
    this._protheusSelected = protheusSelected;
    this._sgdbKind = protheusSelected.sgdbData.templateId ? 'template' : 'recipe';
    this.protheusUpdateModal.open();
  }

  cannotRename(protheusSelected): boolean {
    return this.status_Processing.includes(protheusSelected.deployStats.toLowerCase());
  }

  cannotShare(protheusSelected): boolean {
    return protheusSelected.username !== this.mainService.userToken.username;
  }

  cannotRestart(protheusSelected): boolean {
    if (protheusSelected.deployStats.toLowerCase() === "restarting protheus") return false;

    return (this.status_Processing.includes(protheusSelected.deployStats.toLowerCase())
      || this.status_deleted.includes(protheusSelected.deployStats.toLowerCase()));
  }

  cannotEditINI(protheusSelected): boolean {
    return this.status_Processing.includes(protheusSelected.deployStats.toLowerCase());
  }

  cannotDelete(protheusSelected): boolean {
    if (protheusSelected.username !== this.mainService.userToken.username) {
      return true;
    }
    return this.status_Processing.includes(protheusSelected.deployStats.toLowerCase());
  }

  shareResource(instanciaSelect) {
    this.usersInArea = [];
    this.protheusIdToShare = instanciaSelect['id'];
    this.usersSelected = instanciaSelect['shared'];

    let usersUpdated = this.usersSelected.map(user => {
      return {label: user, value: user}}
    );
    this.usersInArea = usersUpdated;
    this.shareModal.open();
  }

  shareInstance() {
    this.protheusService.shareProtheus(this.protheusIdToShare, this.usersSelected)
      .subscribe(res => {
        this.loading = false;
      });
      this.getAllProtheus();
  }

  deleteProtheus(protheusSelected) {
    this._id = protheusSelected['id'];
    this.deleteProtheusModal.open();
  }

  getReleaseName(releaseId: string) {
    let releaseName: string = "NOT_FOUND";
    this.releases.map(release => {
      if ( release.id === releaseId ) releaseName = release.name;
    })
    return releaseName;
  }

  getLocaleName(localeID: string) {
    let localeName: string = "NOT_FOUND"
    this.localizacoes.map(localizacao => {
      if ( localizacao.id === localeID ) localeName =  localizacao.localizacao;
    })
    return localeName;
  }

  getOriginalIniToModifiy(protheusSelected) {
    this.objetosIni = [];
    this.loading = true;
    this.INIformVisible = false;
    this._ini = protheusSelected['id'];
    this.protheusService.getINItoEdit(protheusSelected['id'])
      .subscribe({
        next: ((response) => {
          this._fullINIToEdit = response;
            response.forEach(element => {
              this.objetosIni = [...this.objetosIni, { label: element.instance + ' - ' + element.type, value: element }]
            });
            this.loading = false;
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
            this.poNotification.message = "Erro ao obter o nome da base!";
            this.poNotificationService.error(this.poNotification);
          })
        });

    this.iniToEditFields = [];
    this.iniToEditValues = {};
    this.iniToEditGroups = [];
    this.fieldsToSelect = [];
    this.editINIProtheusModal.open();
  }

  onChangeobjetosIni(iniSelected) {
    if ( iniSelected !== undefined ){
      this.iniToEditFields = [];
      this.iniToEditValues = {};
      this.iniToEditGroups = [];
      this.fieldsToSelect = [];
      this.previousIni = JSON.parse(JSON.stringify(iniSelected));
      this.extractInfoFromINI(iniSelected);
    }
  }

  resetFormValues() {
    this.iniToEditFields = [];
    this.iniToEditValues = {};
    this.iniToEditGroups = [];
    this.fieldsToSelect = [];
    this.extractInfoFromINI(this.iniObject);
  }

  resetFormValuesFromIni(){
    this.iniToEditFields = [];
    this.iniToEditValues = {};
    this.iniToEditGroups = [];
    this.fieldsToSelect = [];
    this.extractInfoFromINI(this.previousIni);
  }

  resetIniValues() {
    this.objetosIni = [];
    this.INIformVisible = false;
    this.iniToEditFields = [];
    this.iniToEditValues = {};
    this.iniToEditGroups = [];
    this.fieldsToSelect = [];
    this.iniObject = '';
    this.iniInstance = '';
    this.iniType = '';
    this._iniToEdit = [];
    this.objetoSelecionado = {};
    this.editINIProtheusModal.close()
  }

  extractInfoFromINI(iniObject) {

    this.iniObject = iniObject;
    this.iniInstance = iniObject.instance;
    this.iniType = iniObject.type;
    this._iniToEdit = iniObject.ini;

    this._iniToEdit.forEach(iniElement => {
      let countDivider = 0;
      let iniElementTemp = new IniParameter();
      iniElementTemp.group = iniElement.group;
      iniElementTemp.values = iniElement.keys;
      iniElementTemp.protected = iniElement.protected;

      let keys = Object.keys(iniElementTemp.values);
      this.iniToEditGroups = [...this.iniToEditGroups, { label: 'Adicionar novo Grupo', value: 'NEWGROUP' }];

      iniElementTemp.values.forEach(element => {
        let value = element['value'];
        let property_name = iniElementTemp.group + '-' + element['key'];
        let objectfield: objectForm = {
          label: element['key'],
          property: property_name,
          required: true,
          minLength: 1,
          gridColumns: 6,
          gridSmColumns: 6,
          disabled: false,
          fieldValue: value,
          value: value
        }
        if ( element['protected'] === false ) this.fieldsToSelect = [...this.fieldsToSelect, {label: property_name, value: property_name}]
        if ( countDivider === 0 ) {
          countDivider = 1;
          objectfield.divider = iniElementTemp.group;
          this.iniToEditGroups = [...this.iniToEditGroups, { label: iniElementTemp.group, value: iniElementTemp.group }];
        }

        if ( element['protected'] === true ) objectfield.disabled = true;

        // this.iniToEditFields = [...this.iniToEditFields, objectfield];
        this.iniToEditFields = [...this.iniToEditFields, objectfield];
        this.iniToEditValues[property_name] = value;
      });

    });

    this.INIformVisible = true;
  }

  startNewFields(){

    this.newFieldsINI = [];
    this.newValuesINI = {}
    let firstKey: objectForm = {
      label: 'Chave',
      property: 'key-1',
      required: true,
      minLength: 1,
      gridColumns: 6,
      gridSmColumns: 6,
      disabled: false,
      fieldValue: ''
    }

    let firstValue: objectForm = {
      label: 'Valor',
      property: 'value-1',
      required: true,
      minLength: 1,
      gridColumns: 6,
      gridSmColumns: 6,
      disabled: false,
      fieldValue: ''
    }
    this.newFieldsINI = [ firstKey, firstValue];
  }

  addFieldValueDynamicForm() {
    let length =  Object.keys(this.newValuesINI).length;
    let keyProperty = 'key-' + ((length/2) +1)
    let valueProperty = 'value-' + ((length/2) +1)
    let newKey: objectForm = {
      label: 'Chave',
      property: keyProperty,
      required: true,
      minLength: 1,
      gridColumns: 6,
      gridSmColumns: 6,
      disabled: false,
      fieldValue: ''
    }

    let newValue: objectForm = {
      label: 'Valor',
      property: valueProperty,
      required: true,
      minLength: 1,
      gridColumns: 6,
      gridSmColumns: 6,
      disabled: false,
      fieldValue: ''
    }
    this.newFieldsINI = [... this.newFieldsINI, newKey, newValue];

  }

  extractValuesFromNewKeys(){
    let values: Array<any> = [];
    for (const [k, v] of Object.entries(this.newValuesINI)) {
      const type = k.split('-', 1)[0];
      const number = k.split('-', 2)[1];
      if (type === 'key') {
        let value = 'value-' + number;
        values = [...values, {key: this.newValuesINI[k], value: this.newValuesINI[value], protected: false}]
      }
    }
    this.addValueToIni(values);
  }

  addValueToIni(values) {
    if (this.newGroup) {
      //adiciona um grupo novo no this.iniObject
      let newGroup = { group: this._newGroup, keys: values}
      this.iniObject['ini'] = [...this.iniObject['ini'], newGroup]
    } else {
      let existGroup = {};
      existGroup = this.iniObject['ini'].find(obj => obj['group'] === this.groupINI);
      const groupIndex = this.iniObject['ini'].indexOf(existGroup);

      values.forEach(element => {
        this.iniObject['ini'][groupIndex].keys = [...this.iniObject['ini'][groupIndex].keys, element]
      })

    }
    this.resetFormValues();

  }

  deleteFieldsFromIni() {
    this.fieldsToDelete.forEach(element => {
      const group = element.split('-', 1)[0];
      const key = element.split('-', 2)[1];

      let existGroup = {};
      existGroup = this.iniObject['ini'].find(obj => obj['group'] === group);
      const groupIndex = this.iniObject['ini'].indexOf(existGroup);

      let existKey = {};
      existKey = this.iniObject['ini'][groupIndex].keys.find(obj => obj['key'] === key);
      const keyIndex = this.iniObject['ini'][groupIndex].keys.indexOf(existKey);
      this.iniObject['ini'][groupIndex].keys.splice(keyIndex, 1);

      this.resetFormValues();

    });
  }

  onChangeShouldInsert(groupSelected){
    if (groupSelected === 'NEWGROUP') {
      this.newGroup = true;
    } else {
      this.newGroup = false;
    }
  }

  convertValuesToINI() {
    let iniInstanceIndex = {};
    iniInstanceIndex = this.iniObject;
    for (const [k, v] of Object.entries(this.iniToEditValues)) {
      // k Type is string
      // v Type is any
      const serviceName = iniInstanceIndex['name'] as string;
      const getGroupAndKeyFromProperty = (key: string): {group: string | undefined; key: string | undefined} => {
        if (key.startsWith(serviceName)) {
          const escapedName = serviceName.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          const regex = new RegExp(`^(${escapedName}[^-]*)-(.*)$`);
          const match = key.match(regex);

          if (match) {
            return { group: match[1], key: match[2] };
          }

          return { group: undefined, key: undefined };
        } else {
          const splitIndex = key.indexOf('-');

          return { group: key.slice(0, splitIndex), key: key.slice(splitIndex + 1) };
        }
      }
      const {group, key} = getGroupAndKeyFromProperty(k);

      let existGroup = {};
      existGroup = iniInstanceIndex['ini'].find(obj => obj['group'] === group);
      const groupIndex = iniInstanceIndex['ini'].indexOf(existGroup);

      let existKey = {};
      existKey = this.iniObject['ini'][groupIndex].keys.find(obj => obj['key'] === key);
      const keyIndex = this.iniObject['ini'][groupIndex].keys.indexOf(existKey);

      if( existGroup && existKey ) {
        const oldValue = iniInstanceIndex['ini'][groupIndex].keys[keyIndex];
        if ( oldValue !== undefined ) {
          if( oldValue.value !== v ) iniInstanceIndex['ini'][groupIndex].keys[keyIndex].value = v;
        } else {
          iniInstanceIndex['ini'][groupIndex].keys = [...iniInstanceIndex['ini'][groupIndex].keys, {key: key, value: v, protected: false}];
        }
      } else {
        if( existGroup ) {
          iniInstanceIndex['ini'][groupIndex].keys = [...iniInstanceIndex['ini'][groupIndex].keys, {key: key, value: v, protected: false}];
        } else {
          let tempkeyValue = {key: key, value: v, protected: false}
          let tempObject: tempIniGroup = {
            group: group,
            keys: [tempkeyValue]
          }
          iniInstanceIndex['ini'] = [...iniInstanceIndex['ini'], tempObject];
        }

      }
    }

    this.protheusService.saveINIEdited(this._ini, iniInstanceIndex)
      .subscribe(
        res => {
          this.poNotification.message = "INI salvo e em processo de atualização";
          this.poNotificationService.success(this.poNotification);
        }
      );
  }

// AQUI
  software:Array<any> = [
    { label: 'Oracle', value: 'oracle' },
    { label: 'Postgres', value: 'postgres' },
    { label: 'MSSQL', value: 'mssql' }
  ];
  softwareSelected: string = '';

  regions: Array<Region> = [];
  regionSelected: Region;
  regionSelectedId: string = '';

  tagSelection?: string = '';
  tagSelectionOptions: Array<PoSelectOption> = [];

  _allWorkers:Array<any> = [];
  _workers:Array<any> = [];
  _tags:Array<any> = [];
  _tagsSelected:Array<any> = [];

  tagSelectionProtheus?: string = '';
  tagSelectionOptionsProtheus: Array<PoSelectOption> = [];

  _allProtheusWorkers: Array<any> = [];
  _protheusWorkers: Array<any> = [];
  _protheusTagsAvailable: Array<any> = [];
  _protheusTagsSelected: Array<any> = [];

  baseSelectOrig:Array<any> = [];

  updateComponents() {
    let temp1 = {};
    for (let tag of this._tags) {
      let {value, label, group} = tag;
      if (!(group in temp1))
        temp1[group] = {label: group, options: [{label, value}]}
      temp1[group].options.push({label, value})
    }
    this.tagSelection = '';
    this.tagSelectionOptions = Object.values(temp1);
  }

  updateComponentsStructures() {
    this._workers = this.filterWorkersByTags(this._allWorkers, this._tagsSelected);
    this._tags = this.getWorkersTags(this._workers);
    this._tags = this._tags.filter(e1 => !(this._tagsSelected.find(e2 => e2.value === e1.value)));
  }

  pushTagsValues(value:string, removable:boolean) {
    if (this._tagsSelected.find(e1 => e1.value === value))
      return;

    let tempTag = this._tags.find(e1 => e1.value === value);
    if (!tempTag) return;

    tempTag.removable = removable;
    this._tagsSelected.push(tempTag);

    this.updateComponentsStructures();
    this.updateComponents();
  }

  removeTagsValues(value: string) {
    this._tagsSelected = this._tagsSelected.filter(e1 => e1.value !== value);

    this.updateComponentsStructures();
    this.updateComponents();
  }

  resetTagsValues() {
    this._tagsSelected = [];
    this.updateComponentsStructures();
    this.updateComponents();
  }

  getWorkers(region:Region, type:string) {
    if (!region.workers) return [];
    return region.workers.filter(e => e.type === type);
  }

  getWorkersTags(workers:any) {
    let tags:any = [];
    for (let worker of workers) {
      for (let tag of worker.tags) {
        if (tags.find(e => e.value === tag.value))
          continue;
        tags.push(tag);
      }
    }
    return tags;
  }

  filterWorkersByTags(workers:any, tags:any) {
    let remove:any = [];
    for (let worker of workers) {
      for (let tag of tags) {
        if (!worker.tags.find(e => e.value === tag.value)) {
          remove.push(worker);
          break;
        }
      }
    }
    return workers.filter(e1 => !remove.find(e2 => e2.name === e1.name));
  }

  onChangeRegion(element) {
    this.regionSelected = this.regions.find(e => e.id === element)!;

    this._allWorkers = this.getWorkers(this.regionSelected, "database");
    this._workers = this._allWorkers;
    this._tags = this.getWorkersTags(this._workers);

    this._allProtheusWorkers = this.getWorkers(this.regionSelected, "protheus");
    this._protheusWorkers = this._allProtheusWorkers;
    this._protheusTagsAvailable = this.getWorkersTags(this._protheusWorkers);

    let softwares:Array<Software> = [];
    for (let tag of this._tags) {
      if (tag.field === 'database') {
        let software = new Software();
        software.label = tag.label;
        software.value = tag.value;
        softwares.push(software);
      }
    }

    if (softwares.length > 0) {
      this.software = softwares;
    }

    this.softwareSelected = '';

    this.resetTagsValues();
    this.pushTagsValues(this.regionSelected.name, false);

    this.resetProtheusTagsValues();
    this.pushProtheusTagsValues(this.regionSelected.name, false);
  }

  onChangeSoftware(element) {
    this.resetFields('software');

    if (this.baseSelectOrig.length === 0)
      this.baseSelectOrig = this.baseSelect;
    this.baseSelect = this.baseSelectOrig.filter(e1 => e1.label.toLowerCase().includes(element.toLowerCase()));

    this.pushTagsValues(element, false);
  }

  get disableIdioma(): boolean { return !this._release; }
  get disableLocalizacao(): boolean { return !this._idioma; }
  get disableRPO(): boolean { return !this._localizacao; }
  get disableAppserver(): boolean { return !this._rpo; }
  get disableDbaccess(): boolean { return !this._appserver; }
  get disableSoftware(): boolean { return !this._dbaccess; }
  get disableDatabase(): boolean { return !this.softwareSelected; }
  get disableTagSelection(): boolean { return !this._sgdbType; }
  get disableTagSelectionProtheus(): boolean { return !this._sgdbType; }

  onChangeTagSelection(feature) {
    this.pushTagsValues(this.tagSelection!, true);
    this.tagSelection = undefined;
  }

  onRemoveTag(feature) {
    this.removeTagsValues(feature.value);
  }

  updateProtheusComponents() {
    let temp1 = {};
    for (let tag of this._protheusTagsAvailable) {
      let {value, label, group} = tag;
      if (!(group in temp1))
        temp1[group] = {label: group, options: [{label, value}]}
      temp1[group].options.push({label, value})
    }
    this.tagSelectionProtheus = '';
    this.tagSelectionOptionsProtheus = Object.values(temp1);
  }

  updateProtheusComponentsStructures() {
    this._protheusWorkers = this.filterWorkersByTags(this._allProtheusWorkers, this._protheusTagsSelected);
    this._protheusTagsAvailable = this.getWorkersTags(this._protheusWorkers);
    this._protheusTagsAvailable = this._protheusTagsAvailable.filter(e1 => !(this._protheusTagsSelected.find(e2 => e2.value === e1.value)));
  }

  pushProtheusTagsValues(value: string, removable: boolean) {
    if (this._protheusTagsSelected.find(e1 => e1.value === value))
      return;

    let tempTag = this._protheusTagsAvailable.find(e1 => e1.value === value);
    if (!tempTag) return;

    tempTag.removable = removable;
    this._protheusTagsSelected.push(tempTag);
    this.updateProtheusComponentsStructures();
    this.updateProtheusComponents();
  }

  removeProtheusTagsValues(value: string) {
    this._protheusTagsSelected = this._protheusTagsSelected.filter(e1 => e1.value !== value);
    this.updateProtheusComponentsStructures();
    this.updateProtheusComponents();
  }

  resetProtheusTagsValues() {
    this._protheusTagsSelected = [];
    this.updateProtheusComponentsStructures();
    this.updateProtheusComponents();
  }

  onChangeTagSelectionProtheus(feature) {
    this.pushProtheusTagsValues(this.tagSelectionProtheus!, true);
    this.tagSelectionProtheus = undefined;
  }

  onRemoveTagProtheus(feature) {
    this.removeProtheusTagsValues(feature.value);
  }

  getRegions() {
    this.loading = true;
    this.protheusService.getRegions()
      .subscribe({
          next: ((response) => {
            response.forEach(element => {
              const regionTemp = new Region();

              regionTemp.id = element._id || element.id;
              regionTemp.name = element.name;
              regionTemp.label = element.displayName;
              regionTemp.value = element._id || element.id;
              regionTemp.workers = element.workers;
              regionTemp.roles = element.roles;

              this.regions = [...this.regions, regionTemp];
            });

            this.loading = false;
          }),
          complete: (() => {
            if (this.regions.length === 1) {
              this.onChangeRegion(this.regions[0].id);
            }
          }),
          error: ((msgError) => {
            this.mainService.handleError(msgError);
            this.loading = false;
          })
        });
  }

  hideRegions() {
    return this.regions.length > 1;
  }

  hideTags() {
    return this._tagsSelected.length >0 || this._tags.length > 0
  }

  hideProtheusTags() {
    return this._protheusTagsSelected.length > 0 || this.tagSelectionOptionsProtheus.length > 0;
  }
}
